import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/bg/who-we-help")({
  component: () => <Outlet />,
});
